<template>
	<div>
		<div class="p-5 text-xl w-full flex justify-center items-center" v-if="loading">
			<div>
				<svg class="mr-3 -ml-1 size-8 animate-spin text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
			</div>
			<div>
				Loading, please wait...
			</div>
		</div>
		<div class="w-full bg-background mx-5" v-else>
			<!-- Desktop view (horizontal tabs) -->
			<div class="flex border-t">
				<div class="border-r">
					<div class="w-full flex flex-col ">
						<div class="p-3 flex justify-between border-b item-center">
							<div class="text-subtitle pr-10 ">Groups
							</div>
							<div >
								<Button size="sm" @click.prevent="addGroup()">Add New</Button>
							</div>         
						</div>
						<div v-for="(group, groupIndex) in metaGroups">
							<div class="mb-2  border-b-2 text-sm  p-2 hover:border-primary " :class="{'border-primary ':groupFilter==group.grouping,'border-background ':groupFilter!=group.grouping}"  @click.prevent="setGroupFilter(group.grouping)">
								<span v-if="group.grouping==''">Not Grouped</span>
								<span v-else>{{group.grouping}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="grow">
					<div class="w-full bg-background ">
						<!-- Desktop view (horizontal tabs) -->
						<div class="hidden md:flex justify-between items-center border-b py-2 px-5 ">
							<div class="border-b-2 border-background hover:border-muted-foreground mx-2 px-1 text-center text-subtitle flex-shink-0" :class="{ 'border-primary text-primary': provFilter == '', [`basis-1/${metaProviders.length+1}`]: metaProviders.length> 0 }" > 
								<button class="uppercase text-subtitle mx-auto py-2" @click.prevent="setProviderFilter('');setGroupFilter('')">
									All
								</button>
							</div>
							<div class="border-b-2 border-background hover:border-muted-foreground mx-2 px-1 text-center text-subtitle flex-shink-0"  v-for="(provider,index) in metaProviders"   :key="index" :class="{ 'border-primary text-primary': provFilter === provider.provider, [`basis-1/${metaProviders.length+1}`]: metaProviders.length> 0 }" > 
								<button class="uppercase text-subtitle mx-auto py-1" @click.prevent="setProviderFilter(provider.provider)">
									{{ provider.provider }}
								</button>
							</div>
						</div>

					</div>
					<div class="p-10">

						<VueDraggableNext :list="metaData"  tag="div" @end="saveChanges" >
						<div v-for="(metaItem,metaIndex) in metaData" :key="metaIndex" class="mt-2">
							<Card>
							<CardHeader class="cursor-pointer border-b p-3">
							<div class="w-full flex items-center justify-between">
								<div>
									<CardTitle class="text-base font-light">{{metaItem.label}}</CardTitle>
								</div>
								<div class="text-muted-foreground p-2">
									<ApplicationEditOutlineIcon/>
								</div>
							</div>
							</CardHeader>
							<CardContent class="p-3">
							<div class="grid grid-cols-3 gap-4 items-center">
								<div>
									<Label for="fieldType">Field Type</Label>
									<div class="mt-3">
										<Select v-model="metaItem.type" required >
											<SelectTrigger class="w-full">
											<SelectValue placeholder="Select type" />
											</SelectTrigger>
											<SelectContent>
											<SelectItem value="checkbox">Check Box</SelectItem>
											<SelectItem value="datefield">Date Field</SelectItem>
											<SelectItem value="dropdown">Drop Down List</SelectItem>
											<SelectItem value="multiselect">Multi Select</SelectItem>
											<SelectItem value="freeform">Free Form</SelectItem>
											<SelectItem value="numeric">Numeric</SelectItem>
											<SelectItem value="textarea">Text Area</SelectItem>
											<SelectItem value="textfield">Text Field</SelectItem>
											</SelectContent>

										</Select>
									</div>
								</div>
								<div>
									<Label for="fieldType">Content Type</Label>
									<div class="mt-2">
										<Select v-model="metaItem.provider" required >
											<SelectTrigger class="w-full">
											<SelectValue placeholder="Select usage" />
											</SelectTrigger>
											<SelectContent>
											<template v-for="(provider,provIndex) in metaProviders" >
												<SelectItem :value="provider.provider"> {{ucFirst(provider.provider)}}</SelectItem>
											</template>
											</SelectContent>

										</Select>
									</div>
								</div>
								<div>
									<Label for="fieldType">Group</Label>
									<div class="mt-2">
										<Select v-model="metaItem.provider" required >
											<SelectTrigger class="w-full">
											<SelectValue placeholder="Select usage" />
											</SelectTrigger>
											<SelectContent>
											<SelectItem value="0">None</SelectItem>
											<template v-for="(group, index) in metaGroups" >
												<SelectItem  v-if="group.grouping !== ''" :value="group.grouping">
												{{ group.grouping }}    
												</SelectItem>
											</template>
											</SelectContent>

										</Select>
									</div>
								</div>

							</div>
							<div class="grid grid-cols-2 gap-4">
								<div>
									<NumberField  v-model="metaItem.maxsize" v-if="metaItem.type=='textfield' || metaItem.type=='textarea' || metaItem.type=='freeform'">
									<Label>Max Size</Label>
									<NumberFieldContent class="mt-2">
									<NumberFieldDecrement />
									<NumberFieldInput/> 
									<NumberFieldIncrement />
									</NumberFieldContent>
									</NumberField>
								</div>
								<div class="flex items-start flex-col"  v-if="metaItem.type=='dropdown'">
									<div>
										<Label>Options</Label>
									</div>
									<div class="space-y-2 w-full">
										<ul class="space-y-1" v-if="typeof  metaItem.settings!='undefined' && typeof metaItem.settings.options!='undefined'">
											<li v-for="(option,oIndex) in metaItem.settings.options" :key="oIndex" class="flex items-center justify-between  rounded px-2 py-1" >
												<Input v-model="metaItem.settings.options[oIndex]" class="border-primary"/>
												<div class="flex gap-1">
													<Button size="icon" variant="ghost" @click="moveSelectUp(metaIndex,oIndex)" :disabled="oIndex === 0">
														<ArrowUpDropCircleOutlineIcon class="w-4 h-4" />
													</Button>
												<Button size="icon" variant="ghost" @click="moveSelectDown(metaIndex,oIndex)" :disabled="oIndex === metaItem.settings.options.length - 1">
													<ArrowDownDropCircleOutlineIcon class="w-4 h-4" />
												</Button>
												<Button size="icon" variant="ghost" @click="deleteDDOption(metaIndex,oIndex)">
													<DeleteCircleOutlineIcon class="w-4 h-4 text-destructive" />
												</Button>
												</div>
											</li>
										</ul>

										<div class="flex gap-2">
											<Input v-model="metaItem.settings.defaultValue"  placeholder="Default Value" />
											<Button @click="addDDOption(metaIndex)" size="sm" variant="default">
												+ Add option
											</Button>
										</div>
									</div>
								</div>

							</div>
							<Accordion type="single" collapsible class="mt-3">
							<AccordionItem :value="metaIndex.toString()">
							<AccordionTrigger>Advanced</AccordionTrigger>
							<AccordionContent>
							<div class="flex w-full justify-between">
								<div class="" v-if="metaItem.source === 'api'">
									<Label>Field to populate</Label>
									<Select v-model="metaItem.settings.calculatedField">
										<SelectTrigger> 
										<SelectValue placeholder="Select field" />
										</SelectTrigger>
										<SelectContent>
										<template v-for="(derived, index) in metaData">
											<SelectItem  v-if="derived.source === 'derived'" :value="String(derived.id)">
											{{ derived.label }}
											</SelectItem>           
										</template>     
										</SelectContent>
									</Select>
								</div>
								<div class=" " v-if="metaItem.source === 'api'">
									<Label>Default categories</Label>
									<MultiSelect v-model="metaItem.settings.defaultCategories" :max="100" :allowEmpty="true" label="label" track-by="id" searchable :items="externalCategories" :multiple="true" placeholder="Select relevant" />
								</div>                  
								<div class=" " v-if="metaItem.source !== 'manual'">
									<Label>Delimiter(If multiple)</Label>
									<Input type="text" size="1" v-model="metaItem.settings.delim" />
								</div>                  
								<div class=" ">
									<Label>Required for filetypes (, separated)</Label>
									<Input type="text" size="1" placeholder="Eg. mp4,mov,mpg" v-model="metaItem.settings.requiredTypes" />
								</div>  
								<div class=" ">
									<Label>Remove new lines?</Label>
									<Select v-model="metaItem.settings.removeNewLines">
										<SelectTrigger>         
										<SelectValue placeholder="Select" />
										</SelectTrigger>                
										<SelectContent>                         
										<SelectItem value="yes">Yes</SelectItem>
										<SelectItem value="no">No</SelectItem>
										</SelectContent>                        
									</Select>                       
								</div>                  
							</div>                  

							</AccordionContent>
							</AccordionItem>
							</Accordion>

							</CardContent>
							</Card>


						</div>

						</VueDraggableNext>
					</div>
				</div>

			</div>

		</div>






		<!--
			<div class="row mt-2">
			<div class="col-2">
			<div class="row">
			<div class="col-12">
			<div class="list-group">
			<Button class="mb-2" @click.prevent="addGroup()">
			Add new
			</Button>
			<Button v-for="(group, groupIndex) in metaGroups" variant="ghost" class="list-group-item list-group-item-action text-left justify-start" :class="{ 'bg-primary text-primary-foreground': group.grouping === groupFilter, }" @click.prevent="setGroupFilter(group.grouping)">
			<span v-if="group.grouping === ''">No Group</span>
			<span v-if="group.grouping === '_newGroup'">
			<Input type="text" class="form-control" v-model="newGroup" @keyup.enter="commitGroup(groupIndex)" />
			<small class="text-white">Press enter to save.</small>
			</span>
			<span v-else>
			{{ group.grouping }}
			</span>
			</Button>
			</div>
			</div>
			</div>
			</div>
			<div class="col-10 p-2">
			<div class="row">
			<div class="col-12">
			<div class="form-group row">
			<div class="col-12 col-md-1"></div>
			<div class="col-12 col-md-1">
			<h5>Field Type</h5>
			</div>
			<div class="col-12 col-md-2">
			<h5>Key</h5>
			</div>
			<div class="col-12 col-md-3">
			<h5>Values</h5>
			</div>
			<div class="col-12 col-md-1">
			<h5>Max Size</h5>
			</div>
			<div class="col-12 col-md-1">
			<h5>Group</h5>
			</div>
			<div class="col-12 col-md-1">
			<h5>Type</h5>
			</div>
			<div class="col-12 col-md-1">
			<h5>Source</h5>
			</div>
			<div class="col-12 col-md-1">
			<h5>Action</h5>
			</div>
			</div>
			<template #item="{metaItem,index}"  >
			<div class="list-group-item"  v-if=" (provFilter === '' || provFilter === metaItem.provider) && (groupFilter === '' || groupFilter === metaItem.grouping || typeof metaItem.grouping === 'undefined') " >
			<div class="form-group row p-0">
			<div class="col-12 col-md-1">
			<span class="text-success display-5 pr-3 handle">
			<i class="fas fa-grip-lines"></i>
			</span>
			<Button variant="ghost" size="icon" @click.prevent="moveUp(index)"><i class="fas fa-arrow-up"></i> </Button>
			<Button variant="ghost" size="icon" @click.prevent="moveDown(index)"><i class="fas fa-arrow-down"></i> </Button>
			</div>
			<div class="col-12 col-md-1" v-if="typeof metaItem.type !='undefined'">
			<Select v-model="metaItem.type" required>
			<SelectTrigger class="form-control-sm">
			<SelectValue placeholder="Select type" />
			</SelectTrigger>
			<SelectContent>
			<SelectItem value="checkbox">Check Box</SelectItem>
			<SelectItem value="datefield">Date Field</SelectItem>
			<SelectItem value="dropdown">Drop Down List</SelectItem>
			<SelectItem value="multiselect">Multi Select</SelectItem>
			<SelectItem value="freeform">Free Form</SelectItem>
			<SelectItem value="numeric">Numeric</SelectItem>
			<SelectItem value="textarea">Text Area</SelectItem>
			<SelectItem value="textfield">Text Field</SelectItem>
			</SelectContent>
			</Select>
			</div>
			<div class="col-12 col-md-2">
			<Input type="text" placeholder="Label" class="form-control-sm" v-model="metaItem.label" />
			</div>
			<div class="col-12 col-md-3">
			<Input v-if="metaItem.type === 'textfield'" type="text" placeholder="Default Value" class="form-control-sm" v-model="metaItem.settings.defaultValue" required />
			<Textarea v-if="metaItem.type === 'textarea'" type="text" placeholder="Default Value" class="form-control-sm" v-model="metaItem.settings.defaultValue" required />
			<Input v-if="metaItem.type === 'datefield'" type="date" class="form-control-sm" v-model="metaItem.settings.defaultValue" required />
			<div v-if="metaItem.type === 'multiselect'">
			<div v-for="(option, oIndex) in metaItem.settings.options" class="form-group row pt-0 pb-1 mb-0 mt-0">
			<div class="col-9">
			<Input type="text" class="form-control-sm" placeholder="Option" :model-value="getOption(metaItem, oIndex)" @update:model-value="(val: string | number) => setOption(metaItem, oIndex, val.toString())" />
			</div>
			<div class="col-3">
			<Button variant="ghost" size="icon" class="text-danger" @click.prevent="deleteDDOption(index, oIndex)">
			<i class="fas fa-minus-circle"></i>
			</Button>
			<Button v-if="metaItem.provider === 'quiz'" variant="ghost" size="icon" class="text-success" title="Set Answer" @click.prevent="safeSetAnswer(index, getOption(metaItem, oIndex))" >
			<i class="bi bi-check-circle"></i>
			</Button>
			<Button variant="ghost" size="icon" @click.prevent="moveSelectUp(index, oIndex)">
			<i class="fas fa-arrow-up"></i>
			</Button>
			<Button variant="ghost" size="icon" @click.prevent="moveSelectDown(index, oIndex)">
			<i class="fas fa-arrow-down"></i>
			</Button>
			</div>
			</div>
			<Button class="btn-sm mt-2" @click.prevent="addDDOption(index)">
			<i class="fas fa-plus"></i> Add Option
			</Button>
			<Input type="text" placeholder="Default Value" class="form-control-sm mt-2" v-model="metaItem.settings.defaultValue" required />
			<div class="form-group mt-2">
			<Input v-if="metaItem.provider === 'quiz'" placeholder="Answer" type="text" v-model="metaItem.answer" class="form-control-sm" disabled />
			</div>
			</div>
			<div v-if="metaItem.type === 'dropdown'">
			<div v-for="(option, oIndex) in metaItem.settings.options" class="form-group row pt-0 pb-1 mb-0 mt-0">
			<div class="col-9">
			<Input type="text" class="form-control-sm" placeholder="Option" :model-value="getOption(metaItem, oIndex)" @update:model-value="(val: string | number) => setOption(metaItem, oIndex, val.toString())" />
			</div>
			<div class="col-3">
			<Button variant="ghost" size="icon" class="text-danger" @click.prevent="deleteDDOption(index, oIndex)">
			<i class="fas fa-minus-circle"></i>
			</Button>
			<Button v-if="metaItem.provider === 'quiz'" variant="ghost" size="icon" class="text-success" title="Set Answer" @click.prevent="safeSetAnswer(index, metaItem.settings.options?.[oIndex] || '')" >
			<i class="bi bi-check-circle"></i>
			</Button>
			<Button variant="ghost" size="icon" @click.prevent="moveSelectUp(index, oIndex)">
			<i class="fas fa-arrow-up"></i>
			</Button>
			<Button variant="ghost" size="icon" @click.prevent="moveSelectDown(index, oIndex)">
			<i class="fas fa-arrow-down"></i>
			</Button>
			</div>
			</div>
			<Button class="btn-sm mt-2" @click.prevent="addDDOption(index)">
			<i class="fas fa-plus"></i> Add Option
			</Button>
			<Input type="text" placeholder="Default Value" class="form-control-sm mt-2" v-model="metaItem.settings.defaultValue" required />
			<div class="form-group mt-2">
			<Input v-if="metaItem.provider === 'quiz'" placeholder="Answer" type="text" v-model="metaItem.answer" class="form-control-sm" disabled />
			</div>
			</div>
			<div v-if="metaItem.type === 'checkbox'" class="form-row">
			<div class="col">
			<Input type="text" class="form-control-sm" placeholder="Checked Value" v-model="metaItem.settings.truevalue" />
			</div>
			<div class="col">
			<Input type="text" class="form-control-sm" placeholder="Unchecked Value" v-model="metaItem.settings.falsevalue" />
			</div>
			</div>
			<div class="row mt-1" v-if="metaItem.type === 'checkbox'">
			<div class="col">
			<Input type="text" placeholder="Default Value" class="form-control-sm" v-model="metaItem.settings.defaultValue" required />
			</div>
			</div>
			<Input v-if="metaItem.type === 'c'" type="date" placeholder="Place Holder Text" class="form-control-sm" />
			</div>
			<div class="col-12 col-md-1">
			<Input v-if=" metaItem.type === 'textfield' || metaItem.type === 'textarea' || metaItem.type === 'freeform' " type="number" placeholder="0" class="form-control-sm" v-model="metaItem.maxsize" />
			<span v-else>N/A</span>
			</div>
			<div class="col-12 col-md-1">
			<Select v-model="metaItem.grouping">
			<SelectTrigger class="form-control-sm">
			<SelectValue placeholder="None" />
			</SelectTrigger>
			<SelectContent>
			<SelectItem value="">None</SelectItem>
			<template v-for="(group, index) in metaGroups" >
			<SelectItem  v-if="group.grouping !== ''" :value="group.grouping">
			{{ group.grouping }}
			</SelectItem>
			</template>
			</SelectContent>
			</Select>
			</div>
			<div class="col-12 col-md-1">
			<Select v-model="metaItem.provider">
			<SelectTrigger class="form-control-sm">
			<SelectValue placeholder="None" />
			</SelectTrigger>
			<SelectContent>
			<SelectItem value="">None</SelectItem>
			<template v-for="(provider, provIndex) in metaProviders" >
			<SelectItem :value="provider.provider">
			{{ ucFirst(provider.provider) }}
			</SelectItem>
			</template>
			</SelectContent>
			</Select>
			</div>
			<div class="col-12 col-md-1">
			<Select v-model="metaItem.source">
			<SelectTrigger class="form-control-sm">
			<SelectValue placeholder="Manual" />
			</SelectTrigger>
			<SelectContent>
			?A		<SelectItem value="manual">Manual</SelectItem>
			<SelectItem value="api">External API</SelectItem>
			<SelectItem value="derived">Derived</SelectItem>
			</SelectContent>
			</Select>
			</div>
			<div class="col-12 col-md-1 text-right">
			<Button variant="ghost" size="icon" class="text-secondary" @click.prevent=" showAdvanced[index] = !showAdvanced[index] ">
			<i class="bi bi-sliders"></i>
			</Button>
			<Button variant="ghost" size="icon" class="text-danger" @click.prevent="deleteMetaItem(index, metaItem.id)">
			<i class="bi bi-x-circle"></i>
			</Button>
			</div>
			</div>
			<div class="row" v-if="showAdvanced[index] === true">
			<div class="col-6 form-group" v-if="metaItem.source === 'api'">
			<Label>Field to populate</Label>
			<Select v-model="metaItem.settings.calculatedField">
			<SelectTrigger>
			<SelectValue placeholder="Select field" />
			</SelectTrigger>
			<SelectContent>
			<template v-for="(derived, index) in metaData">
			<SelectItem  v-if="derived.source === 'derived'" :value="String(derived.id)">
			{{ derived.label }}
			</SelectItem>
			</template>
			</SelectContent>
			</Select>
			</div>
			<div class="col-6 form-group" v-if="metaItem.source === 'api'">
			<Label>Default categories</Label>
			<MultiSelect v-model="metaItem.settings.defaultCategories" :max="100" :allowEmpty="true" label="label" track-by="id" :options="externalCategories" :multiple="true" placeholder="Select relevant" />
			</div>
			<div class="col-6 form-group" v-if="metaItem.source !== 'manual'">
			<Label>Delimiter(If multiple)</Label>
			<Input type="text" size="1" v-model="metaItem.settings.delim" />
			</div>
			<div class="col-6 form-group">
			<Label>Required for filetypes (, separated)</Label>
			<Input type="text" size="1" placeholder="Eg. mp4,mov,mpg" v-model="metaItem.settings.requiredTypes" />
			</div>
			<div class="col-6 form-group">
			<Label>Remove new lines?</Label>
			<Select v-model="metaItem.settings.removeNewLines">
			<SelectTrigger>
			<SelectValue placeholder="Select" />
			</SelectTrigger>
			<SelectContent>
			<SelectItem value="yes">Yes</SelectItem>
			<SelectItem value="no">No</SelectItem>
			</SelectContent>
			</Select>
			</div>
			</div>
			</div>
			</template>
			<div class="row mt-2 mb-5">
			<div class="col-12">
			<Button class="btn-sm mb-5" variant="secondary" @click.prevent="addMetaRow()"> <i class="fas fa-plus"></i> Add Field </Button>
			<Button class="btn-sm mb-5 float-right" @click.prevent="saveChanges()"> <i class="fas fa-save"></i> Save Changes </Button>
			</div>
			</div>
			</div>
			</div>
			</div>
			</div>
		-->
		<Dialog>
			<DialogTrigger as-child>
			<Button variant="ghost" class="hidden" id="editModalTrigger">
				Edit
			</Button>
			</DialogTrigger>
			<DialogContent class="sm:max-w-[800px]">
			<DialogHeader>
			<DialogTitle>Edit Default Value</DialogTitle>
			</DialogHeader>
			<Textarea class="w-full min-h-[600px]" />
				<DialogFooter>
				<Button type="submit">Save changes</Button>
				<DialogClose as-child>
				<Button variant="outline">Close</Button>
				</DialogClose>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	</div>
</template>

<script lang="ts" setup>
import { ref, onMounted, watch,Ref,inject } from 'vue'
import { useToast } from '@/components/ui/toast/use-toast'
import { VueDraggableNext } from 'vue-draggable-next'
import axios from 'axios'
import ApplicationEditOutlineIcon from 'vue-material-design-icons/ApplicationEditOutline.vue';
import ArrowDownDropCircleOutlineIcon from 'vue-material-design-icons/ArrowDownDropCircleOutline.vue';
import ArrowUpDropCircleOutlineIcon from 'vue-material-design-icons/ArrowUpDropCircleOutline.vue';
import DeleteCircleOutlineIcon from 'vue-material-design-icons/DeleteCircleOutline.vue';
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Switch } from '@/components/ui/switch'
import { Label } from '@/components/ui/label'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'

import { NumberField, NumberFieldContent, NumberFieldDecrement, NumberFieldIncrement, NumberFieldInput, } from '@/components/ui/number-field'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger, } from '@/components/ui/dialog'
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Sidebar, SidebarContent, SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarMenu, SidebarMenuButton, SidebarMenuItem, } from "@/components/ui/sidebar"
import { Card,  CardFooter,CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import MultiSelect from '@/components/MultiSelect.vue'

const { toast } = useToast()

interface MetaItem {
	id: number
	type: string
	label: string
	required?: boolean
	removeNewLines?: string
	provider: string
	grouping: string
	answer?: string
	maxsize?: number
	position: number
	settings: {
		defaultValue?: string
		options?: string[]
		truevalue?: string
		falsevalue?: string
		calculatedField?: string
		delim?: string
		defaultCategories?: string[]
		requiredTypes?: string
		removeNewLines?: string
	}
	source?: string
}

interface MetaProvider {
	provider: string
}

interface MetaGroup {
	grouping: string
}
interface ExtCategories {
	id: string
	label: string
}

const pTab = ref(10)
const metaData = ref<MetaItem[]>([])
const externalCategories = ref<ExtCategories[]>([])
const showAdvanced = ref<Record<number, boolean>>({})
const metaProviders = ref<MetaProvider[]>([])
const metaGroups = ref<MetaGroup[]>([])
const provFilter = ref('')
const groupFilter = ref('')
const newGroup = ref('')
const updateCount = ref(0)
const saving = ref(false)
const loading = ref(true)
const vhostId = inject<Ref<string>>('vhostId', ref("0"));
const getOption = (item: MetaItem, index: number): string => {
	if (typeof item.settings.options != 'undefined') {
		return item.settings.options[index] ?? ''
	}
	return '';
}

const setOption = (item: MetaItem, index: number, value: string) => {
	if (typeof item.settings.options != 'undefined') {
		item.settings.options[index] = value
	}
}

// Safe answer setter
const safeSetAnswer = (index: number, optionValue: string) => {
	setAnswer(index, optionValue)
}
const ucFirst = (val: string) => {
	return val.charAt(0).toUpperCase() + val.slice(1)
}

const onSave = async () => {
	try {
		await axios.post('/services/json', {
			method: 'vhost.udpateCustomMetaProvidersPositions',
			vhostID: vhostId.value,
			providers: metaProviders.value,
		})
	} catch (error) {
		console.error(error)
		toast({
			title: 'Error',
			description: 'Failed to save provider positions',
			variant: 'destructive',
		})
	}
}

const addGroup = () => {
	metaGroups.value.unshift({ grouping: 'New Group' })
}

const commitGroup = (index: number) => {
	metaGroups.value[index] = { grouping: newGroup.value }
	newGroup.value = ''
}
const updateOption = (item: MetaItem, index: number, value: string) => {
	if (!item.settings.options) {
		item.settings.options = []; // Initialize if undefined
	}
	item.settings.options[index] = value;
}

const setProviderFilter = (type: string) => {
	provFilter.value = type
}

const setGroupFilter = (type: string) => {
	groupFilter.value = type
}

const moveSelectUp = (select: number, index: number) => {
	if (index>0) {
		const options = [...metaData.value[select].settings.options || []]
		;[options[index - 1], options[index]] = [options[index], options[index - 1]]
		metaData.value[select].settings.options = options
	}
}

const moveSelectDown = (select: number, index: number) => {
	const options = metaData.value[select].settings.options || []
	if (index < options.length - 1) {
		;[options[index + 1], options[index]] = [options[index], options[index + 1]]
		metaData.value[select].settings.options = options
	}
}

const moveUp = (index: number) => {
	if (index>0) {
		const temp = [...metaData.value]
		;[temp[index - 1], temp[index]] = [temp[index], temp[index - 1]]
		metaData.value = temp
	}
}

const moveDown = (index: number) => {
	if (index < metaData.value.length - 1) {
		const temp = [...metaData.value]
		;[temp[index + 1], temp[index]] = [temp[index], temp[index + 1]]
		metaData.value = temp
	}
}

const saveChanges = async () => {
	return true;
	saving.value = true
	updateCount.value = metaData.value.length

	try {
		for (const [index, item] of metaData.value.entries()) {
			if (item.id === -1) {
				await axios.post('/services/json', {
					method: 'vhost.insertCustomMeta',
					vhostID: vhostId.value,
					label: item.label,
					type: item.type,
					grouping: item.grouping,
					provider: item.provider,
					answer: item.answer,
					maxSize: item.maxsize,
					position: index,
					settings: item.settings,
				})
			} else {
				const settings: any = {}

				if (item.type === 'textfield' || item.type === 'textarea') {
					settings.defaultValue = item.settings.defaultValue
				}

				if (item.type === 'dropdown' || item.type === 'multiselect') {
					settings.defaultValue = item.settings.defaultValue
					settings.options = item.settings.options
				}

				if (item.type === 'checkbox') {
					settings.truevalue = item.settings.truevalue
					settings.falsevalue = item.settings.falsevalue
					settings.defaultValue = item.settings.defaultValue
				}

				if (item.settings.calculatedField) {
					settings.calculatedField = item.settings.calculatedField
				}
				if (item.settings.delim) {
					settings.delim = item.settings.delim
				}
				if (item.settings.defaultCategories) {
					settings.defaultCategories = item.settings.defaultCategories
				}

				item.required = false
				if (item.settings.requiredTypes) {
					settings.requiredTypes = item.settings.requiredTypes
					if (settings.requiredTypes !== '') {
						item.required = true
					}
				}

				item.removeNewLines = 'no'
				if (item.settings.removeNewLines) {
					settings.removeNewLines = item.settings.removeNewLines
					if (settings.removeNewLines !== '') {
						item.removeNewLines = settings.removeNewLines
					}
				}

				item.position = index
				item.settings = settings

				await axios.post('/services/json', {
					method: 'vhost.updateCustomMeta',
					vhostID: vhostId.value,
					metaID: item.id,
					data: item,
				})
			}
			updateCount.value--
		}

		toast({
			title: 'Success',
			description: 'Changes saved successfully',
		})
	} catch (error) {
		console.error(error)
		toast({
			title: 'Error',
			description: 'Failed to save changes',
			variant: 'destructive',
		})
	} finally {
		saving.value = false
	}
}

const deleteMetaItem = async (index: number, metaId: number) => {
	try {
		await axios.post('/services/json', {
			method: 'vhost.deleteCustomMeta',
			vhostID: vhostId.value,
			metaID: metaId,
		})
		metaData.value.splice(index, 1)
		toast({
			title: 'Success',
			description: 'Item deleted successfully',
		})
	} catch (error) {
		console.error(error)
		toast({
			title: 'Error',
			description: 'Failed to delete item',
			variant: 'destructive',
		})
	}
}

const addMetaRow = () => {
	metaData.value.push({
		id: -1,
		type: 'textfield',
		label: '',
		provider: provFilter.value,
		grouping: groupFilter.value,
		settings: {},
		position: metaData.value.length,
	})
}

const deleteDDOption = (x: number, i: number) => {
	if (metaData.value[x].settings.options) {
		metaData.value[x].settings.options.splice(i, 1)
	}
}

const addDDOption = (i: number) => {
	if (metaData.value[i].settings.options) {
		metaData.value[i].settings.options.push('')
	} else {
		metaData.value[i].settings.options = ['']
	}
}

const setAnswer = (i: number, val: string) => {
	metaData.value[i].answer = val
	toast({
		title: 'Success',
		description: 'Answer set',
	})
}

const get3rdPartyCategories = async () => {
	try {
		const response = await axios.post('/services/json', {
			method: 'vhost.get3rdPartyHeaders',
			vhostID: vhostId.value,
			parentId: 0,
		})
		externalCategories.value = response.data.result
	} catch (error) {
		console.error(error)
		toast({
			title: 'Error',
			description: 'Failed to load 3rd party categories',
			variant: 'destructive',
		})
	}
}

const getCustomMeta = async () => {
	try {
		const [groupsResponse, providersResponse, metaResponse] = await Promise.all([
			axios.post('/services/json', {
				method: 'vhost.getCustomMetaGroupings',
				vhostID: vhostId.value,
			}),
			axios.post('/services/json', {
				method: 'vhost.getCustomMetaProviders',
				vhostID: vhostId.value,
			}),
			axios.post('/services/json', {
				method: 'vhost.getCustomMeta',
				vhostID: vhostId.value,
			}),
		])
		loading.value=false
		if (groupsResponse.data.status === true) {
			metaGroups.value = groupsResponse.data.result
		}

		if (providersResponse.data.status === true) {
			metaProviders.value = providersResponse.data.result
		}

		if (metaResponse.data.status === true) {
			metaData.value = metaResponse.data.result
		} else {
			toast({
				title: 'Error',
				description: metaResponse.data.result,
				variant: 'destructive',
			})
		}
	} catch (error) {
		console.error(error)
		toast({
			title: 'Error',
			description: 'Failed to load custom meta data',
			variant: 'destructive',
		})
	}
}

watch(updateCount, (newVal) => {
	if (newVal === 0) {
		getCustomMeta()
		saving.value = false
	}
})

onMounted(() => {
	getCustomMeta()
	get3rdPartyCategories()
})
</script>

<style scoped>
.handle {
	cursor: move;
}
</style>
